import EsSummaryView, {type EsSummaryViewProps} from '@/pages/components/audit-program/e-section/EsSummaryView';
import {SS_PAGE} from '@/pages/components/audit-program/s-section/constants';

export type SsSummaryViewProps = Omit<EsSummaryViewProps, 'fallback' | 'refCode'> & {
    refCode?: string;
};

/** Ss — Summary sheet for operating effectiveness of controls (reuses Es layout). */
export default function SsSummaryView({refCode = 'Ss', ...rest}: SsSummaryViewProps) {
    return <EsSummaryView {...rest} refCode={refCode} fallback={SS_PAGE}/>;
}
